//React & State
import { useEffect, useState } from 'react';
//--------------------------------------------------
//Routing & Authentication
import { useRouter } from 'next/router';
import { useAuth } from '../../hooks/useAuth';
import { routes } from '../../routes/routes';
import { setPrevRoute } from '@/utils/prevRoute';
//--------------------------------------------------

export function HQRoute({ children }) {
  const router = useRouter();
  const { status, authStatuses, userPermissions, enrollmentPhases, signout } = useAuth();
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    if (status === authStatuses.SIGNED_OUT) {
      setPrevRoute(router.asPath);
      return router.push(routes.login.path);
    } else if (status === authStatuses.SIGNED_IN) {
      setIsVerified(true);
    }
  }, [router, status, authStatuses, enrollmentPhases, signout, userPermissions]);

  if (isVerified) {
    return children;
  } else {
    return null;
  }
}
